import React from 'react';
import injectSheet from 'react-jss';
import ReactQuill from 'react-quill';
import { Subscribe } from 'unstated';
import {
  Card, CardText, CardBody, FormGroup, CardImg
} from 'reactstrap';

import PromptContainer from '../containers/PromptContainer';

const styles = {
  cardContainer: {
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
  },
  card: {
    minWidth: '37.5rem',
    minHeight: '29.63rem',
  },
  title: {
    marginBottom: '0.4rem',
    fontSize: '0.9rem',
    fontFamily: 'Lato, Arial',
    color: '#1F1F1F',
    fontWeight: 'bold',
  },
  description: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
  },
  icon: {
    width: '5rem',
    height: '7rem',
    fontSize: '5rem',
    display: 'inline-block',
  },
  cardHeaderWrapper: {
    display: 'flex',
    marginBottom: '0.5rem',
  },
  textWrapper: {
    display: 'inline-block',
    marginTop: '0.8rem',
    marginLeft: '1rem',
  },
  textArea: {
    maxHeight: '19.63rem',
    minHeight: '19.63rem',
    border: '1px solid #ced4da',
    borderRadius: '0.3125rem',
    '& > .ql-toolbar': {
      position: 'absolute',
      border: 'none',
      zIndex: 9,
      boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
      left: '1rem',
      bottom: '1rem',
      borderRadius: '0.3125rem',
      '& > .ql-formats .ql-picker.ql-expanded .ql-picker-options': {
        marginTop: '-207px',
      },
    },
    '& > .ql-container': {
      position: 'absolute',
      border: 'none',
      width: '100%',
      minHeight: '14.63rem',
      maxHeight: '14.63rem',
    },
  },
  descriptionWrapper: {
    marginBottom: '0.8rem',
  },
  imageWrapper: {
    width: '5rem',
    height: '5rem',
  },
  image: {
    height: '100%',
    width: '100%',
    borderRadius: '4px',
  },
};
const PromptCard = (props) => {
  const {
    classes, icon, title, description, cardInfo, _id, type, image,
  } = props;

  return (
    <Subscribe to={[PromptContainer]}>
      { prompt => (
        <div className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardBody>
              <div className={classes.cardHeaderWrapper}>
                {
                  image ? (<div className={classes.imageWrapper}> <CardImg className={classes.image} top src={image} alt="Card image cap" /> </div>) 
                  : (<div className={classes.icon}>
                      <i className={icon} />
                    </div>)
                }

                <div className={classes.textWrapper}>
                  <CardText className={classes.title}>{`${type} Title:`}</CardText>
                  <CardText className={classes.description}>{title}</CardText>
                </div>
              </div>
              <div>
                {description ? (<div className={classes.descriptionWrapper}><CardText className={classes.title}>{`${type} Blurb:`}</CardText>
                <CardText className={classes.description}>{description}</CardText></div>) : ''}
                <div>
                  <FormGroup className={classes.textAreaWrapper}>
                    <ReactQuill
                      id={`inputbox-${_id}`}
                      value={prompt.state.prompts[_id] || ''}
                      theme="snow"
                      onChange={(e) => { prompt.handleOnChangePrompt(e, cardInfo); }}
                      className={classes.textArea}
                      name={prompt.state.prompts[_id]}
                      placeholder="Add a prompt to show instead-of or in-addition-to the Blurb (optional)"
                    />
                  </FormGroup>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      )}
    </Subscribe>
  );
};

export default injectSheet(styles)(PromptCard);



// WEBPACK FOOTER //
// ./src/components/PromptCard.js